import styles from './BlackFridayBadge.module.css';

/**
 * The BFCM mark that leads every Black Friday band — four overlapping letter circles.
 *
 * The letters are the campaign's own initials and are NOT copy: they stay B·F·C·M in every locale,
 * the way a logotype does, so they carry no catalog key. The band around them is what gets
 * translated. `aria-hidden` for the same reason — the sentence beside it already says what this is,
 * and "B F C M" read out adds nothing.
 */
export function BlackFridayBadge() {
  return (
    <span className={styles.badge} aria-hidden>
      <span className={`${styles.letter} ${styles.b}`}>B</span>
      <span className={`${styles.letter} ${styles.f}`}>F</span>
      <span className={`${styles.letter} ${styles.c}`}>C</span>
      <span className={`${styles.letter} ${styles.m}`}>M</span>
    </span>
  );
}
